import React, { useEffect, useState } from "react";
import styles from "./ImagesSection.module.css";

const ImagesSection: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState<number | undefined>(undefined);
  const imageColumn =
    "https://thehideawayretreat-storage-images234800-staging.s3.amazonaws.com/HeroOriginal.avif";
  const imageRow =
    "https://thehideawayretreat-storage-images234800-staging.s3.amazonaws.com/HeroOriginal.avif";

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);

      const handleResize = () => setWindowWidth(window.innerWidth);

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  const imageSource =
    windowWidth && windowWidth >= 750 ? imageRow : imageColumn;
  const imageAlt =
    "Stunning waterfront RV site in Navarre Florida with a cool vintage Airstream trailer overlooking the Santa Rosa Sound at our waterfront campground near Destin and Pensacola Beach Florida";

  return (
    <div className={styles.imagesSection}>
      <img src={imageSource} alt={imageAlt} className={styles.image} />
    </div>
  );
};

export default ImagesSection;
